export default __webpack_public_path__ + "static/media/telesaleshelp-form-mobile.35ba6fc3.PNG";